import EasterEggHunt from "@/components/dashboard/easterEggHunt/EasterEggHunt";
import { RunestoneBanner } from "@/components/forge/RunestoneBanner";
import { ShieldTwoEligibilityBanner } from "@/components/forge/ShieldTwoEligibilityBanner";
import { SurveyBanner } from "@/components/surveys/SurveyBanner";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
    return (
        <>
            <EasterEggHunt />
            <ShieldTwoEligibilityBanner />
            <RunestoneBanner />
            <SurveyBanner />
            <Outlet />
        </>
    );
}
